// 承載router-view的components
const Start = resolve => {
  import('components/start/start').then(module => {
    resolve(module);
  });
};

export default {
  path: '/travelApply',
  component: Start,
  children: [
    {
      path: 'bookDetails',
      name: '出差申请单订单填写',
      component: resolve =>
        require(['pages/travel-apply/book/book-details.vue'], resolve)
    },
    {
      path: 'orderDetails',
      name: '出差申请单订单详情',
      // 兼容旧入口：整页跳转到 webview 详情
      beforeEnter(to, from, next) {
        import('@/common/utility/utils').then(({ webviewRoutePush }) => {
          webviewRoutePush({
            path: '/personal/authOrderDetails',
            query: to.query || {}
          }, 'replace')
        })
        next(false)
      }
    }
  ]
}
